(function () {
  const carousels = document.querySelectorAll('[data-home-featured-carousel]');

  if (!carousels.length || typeof EmblaCarousel === 'undefined') return;

  carousels.forEach((root) => {
    const viewport = root.querySelector('.carousel-content-wrapper');
    if (!viewport) return;

    const fade = root.querySelector('.home-featured-carousel-fade');
    const prevBtn = root.querySelector('.home-featured-carousel-nav-prev');
    const nextBtn = root.querySelector('.home-featured-carousel-nav-next');

    const embla = EmblaCarousel(viewport, {
      align: 'start',
      loop: false,
      slidesToScroll: 1,
      containScroll: 'trimSnaps',
      duration: 20,
    });

    const sync = () => {
      const canPrev = embla.canScrollPrev();
      const canNext = embla.canScrollNext();

      if (prevBtn) {
        prevBtn.hidden = !canPrev;
        prevBtn.disabled = !canPrev;
      }

      if (nextBtn) {
        nextBtn.hidden = !canNext;
        nextBtn.disabled = !canNext;
      }

      if (fade) {
        fade.hidden = !canNext;
      }
    };

    embla.on('reInit', sync);
    embla.on('select', sync);
    sync();

    if (prevBtn) {
      prevBtn.addEventListener('click', () => embla.scrollPrev());
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => embla.scrollNext());
    }

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        embla.scrollPrev();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        embla.scrollNext();
      }
    });
  });
})();
